import React from 'react';

const TESTIMONIALS = [
  { init: 'SR', name: 'Suresh Rajan', role: 'Homeowner, Salem', text: "Muster Construct turned my dream home into reality within budget and before schedule. The quality of finishings and the team's transparency throughout the project was remarkable. Highly recommend to anyone in Salem." },
  { init: 'PK', name: 'Priya Krishnamurthy', role: 'Business Owner, Coimbatore', text: "We chose Muster for our commercial complex and they delivered on every promise. Their PEB structure team was professional, fast, and the end result exceeded our expectations." },
  { init: 'MV', name: 'Mohan Venkatesh', role: 'Property Developer, Salem', text: "I've partnered with Muster on three residential projects now. Karthikeyan and his team bring real engineering expertise and an architect's eye for detail. Their consultation alone saved us significant design costs." },
  { init: 'AR', name: 'Anita Rajendran', role: 'Homeowner, Coimbatore', text: "The tensile structure Muster designed for our courtyard is stunning and structurally solid. From initial design to the final installation, every step was handled with care and communication. Outstanding work." },
];

export default function Testimonials() {
  return (
    <section id="testimonials" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.86)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <p style={{
            fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 600,
            letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
          }}>Client Stories</p>
          <h2 style={{
            fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
            textTransform: 'uppercase', lineHeight: 1
          }}>
            What Clients <span style={{ color: 'var(--gold)' }}>Say</span>
          </h2>
        </div>
        <div className="tgrid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={t.name} className="reveal"
              style={{
                background: 'rgba(250,250,250,0.55)', border: '1px solid #1E2823',
                padding: '2rem', backdropFilter: 'blur(4px)', transitionDelay: `${i * 0.1}s`
              }}>
              <div style={{
                fontFamily: 'var(--fh)', fontSize: '5rem', fontWeight: 800,
                color: 'var(--gold)', lineHeight: 0.5, marginBottom: '1rem', opacity: 0.3
              }}>"</div>
              <p style={{
                fontSize: '1rem', fontWeight: 500, lineHeight: 1.8, color: 'var(--lt)',
                marginBottom: '1.5rem', fontStyle: 'italic'
              }}>{t.text}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                  width: 44, height: 44, background: 'var(--gold)', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'var(--fh)', fontWeight: 800, color: 'var(--dk)', fontSize: '1rem', flexShrink: 0
                }}>
                  {t.init}
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--fh)', fontWeight: 700, fontSize: '0.95rem' }}>{t.name}</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--muted)' }}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:900px){.tgrid{grid-template-columns:1fr!important}}`}</style>
    </section>
  );
}
